/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

export default {
      TeleAssignedClaims: '$MHF_ModelNameVal_$MHF|TeleAssignedClaims',

};
